import { render } from "./DefaultMicrophoneSlot.vue?vue&type=template&id=4336e400&scoped=true"
import script from "./DefaultMicrophoneSlot.vue?vue&type=script&lang=js"
export * from "./DefaultMicrophoneSlot.vue?vue&type=script&lang=js"

import "./DefaultMicrophoneSlot.vue?vue&type=style&index=0&id=4336e400&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4336e400"]])

export default __exports__